import { Component, input } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SharedModule } from 'src/app/core/shared.module';
import { inputVariants } from './input.variants';

@Component({
  selector: 'v-input-v2',

  imports: [ReactiveFormsModule, SharedModule, FormsModule],
  templateUrl: './input.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class VInputV2Component {
  /**
   * Which type of input to use
   */
  readonly type = input('text');

  /**
   * Placeholder text to display
   */
  readonly placeholder = input('Enter text');

  readonly size = input<'sm' | 'md' | 'lg'>('md');

  /**
   * Optional form control name
   */
  readonly fControlName = input<string>();

  /**
   * Optionally sets the test id for the input
   */
  readonly testId = input<string>();

  /**
   * Optional autocomplete attribute
   */
  readonly autocomplete = input<string>();

  get classNames() {
    return inputVariants({
      size: this.size(),
    });
  }
}
